import React, { useState } from 'react';
import { AppProvider } from './context/AppContext';
import AppLayout from './components/AppLayout';
import Confetti from './components/Confetti';
import DebugPanel from './components/DebugPanel';
import './styles/App.css';

const App: React.FC = () => {
  const [showConfetti, setShowConfetti] = useState(false);

  const triggerConfetti = () => {
    setShowConfetti(true);
  };

  const handleConfettiComplete = () => {
    setShowConfetti(false);
  };

  return (
    <AppProvider initialTableCount={20}>
      <AppLayout onServed={triggerConfetti} />
      <Confetti show={showConfetti} onComplete={handleConfettiComplete} />
      <DebugPanel />
    </AppProvider>
  );
};

export default App;
